module.exports = __webpack_public_path__ + "static/img/hddlbj.cca0dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hddlbj.png
// module id = m+W+
// module chunks = 1